export default __webpack_public_path__ + "c9cb05e1c32469b6f9a860ee2b970fc9.svg";